import { render, staticRenderFns } from "./listagemCredenciados.vue?vue&type=template&id=095a80e0&lang=pug&"
import script from "./listagemCredenciados.vue?vue&type=script&lang=js&"
export * from "./listagemCredenciados.vue?vue&type=script&lang=js&"
import style0 from "./listagemCredenciados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports